import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";


interface CountriesState {
    countries: Country[];
    selectedCountry: Country | null;
}
const initialState: CountriesState = {
    countries: [],
    selectedCountry: null,
};

export const getCountries = createAsyncThunk(
  "contacts/getCountries",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("api/services/app/Country/GetAll");
      return response.data.result.items as Country[];
    } catch (error: any) {
      return rejectWithValue({
        message: "Failed to fetch countries",
        code: "GET_COUNTRIES_FAILED",
      });
    }
  }
);
const countriesSlice = createSlice({
    name: "countries",
    initialState,
    reducers: {
        setSelectedCountry: (state, action) => {
            state.selectedCountry = action.payload;
        },
        
    },
    extraReducers: (builder) => {
        builder.addCase(getCountries.fulfilled, (state, action) => {
            state.countries = action.payload;
            state.selectedCountry = action.payload.filter(country => country.twoLetterIsoCode ==='US')[0] || null; 
        });
        builder.addCase(getCountries.rejected, (state, action) => {
            console.error("Failed to fetch countries:", action.payload);
        });
    }
});

export const countriesActions = countriesSlice.actions;
export default countriesSlice.reducer